import { render, staticRenderFns } from "./GroupListItem.vue?vue&type=template&id=bb45c60c&scoped=true"
import script from "./GroupListItem.vue?vue&type=script&lang=ts"
export * from "./GroupListItem.vue?vue&type=script&lang=ts"
import style0 from "./GroupListItem.vue?vue&type=style&index=0&id=bb45c60c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb45c60c",
  null
  
)

export default component.exports